<div
  class="info-accordion-header ice-info-accordion-header {{ type }}"
  [attr.data-testid]="testId()"
  [ngClass]="{ hover: !isOpen }"
  (click)="toggleInfoAccordion.emit(!isOpen)"
>
  @if (displayIcon) {
    <div class="header-icon">
      <mat-icon class="header-icon" [svgIcon]="icon" />
    </div>
  }
  <div class="header-text">
    <ng-content />
  </div>
  <div class="header-button">
    <button data-ignore-lint mat-icon-button tabindex="0">
      <mat-icon
        class="rotate-animation"
        [ngClass]="{ 'rotate-animation-toggle': rotationState !== 'rotated' }"
        [svgIcon]="IconNames.ice_chevron_down_narrow"
      />
    </button>
  </div>
</div>
